import React, { useState, useEffect } from 'react';
import apiClient from '../utils/api';
import { Button } from './ui/button';
import { Heart } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { toast } from 'sonner';

export default function FavoriteButton({ artistId, size = 'default' }) {
  const { isAuthenticated } = useAuthStore();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && artistId) {
      checkFavorite();
    }
  }, [isAuthenticated, artistId]);

  const checkFavorite = async () => {
    try {
      const response = await apiClient.get(`/favorites/check/${artistId}`);
      setIsFavorite(response.data.is_favorite);
    } catch (error) {
      // Silent fail
    }
  };

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    
    if (!isAuthenticated) {
      toast.error('Please sign in to save favorites');
      return;
    }

    setLoading(true);
    try {
      if (isFavorite) {
        await apiClient.delete(`/favorites/${artistId}`);
        setIsFavorite(false);
        toast.success('Removed from favorites');
      } else {
        await apiClient.post(`/favorites/${artistId}`);
        setIsFavorite(true);
        toast.success('Added to favorites');
      }
    } catch (error) {
      toast.error('Failed to update favorites');
    } finally {
      setLoading(false);
    }
  };

  const sizeClasses = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
  const iconSize = size === 'sm' ? 16 : 20;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleFavorite}
      disabled={loading}
      className={`${sizeClasses} rounded-full glass-heavy hover:bg-white/20 transition-all ${
        isFavorite ? 'text-red-500' : 'text-white/60 hover:text-red-400'
      }`}
    >
      <Heart
        size={iconSize}
        className={isFavorite ? 'fill-red-500' : ''}
      />
    </Button>
  );
}
